<ep-partner-contacts [selectedPartner]=selectedPartner [selectedPartnerId]="selectedPartnerId"></ep-partner-contacts>